import { useState } from "react";

export const useRefresh = () => {
  const [, rawRefresh] = useState({});

  return () => {
    rawRefresh({});
  };
};
